import { DEVICE_RESOLUTION } from "../../app-constants";
import React, { useEffect, useState } from "react";

const BlackFridayLeaderBoardNavMenu = () => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="mt-3 lg:mt-4">
      <a href={"/christmas-leaderboard"} title={"CHRISTMAS LEADERBOARD"} className={"cursor-pointer"}>
        <img
          src={
            isMobile
              ? "/assets/images/leaderboard/nav-leaderboard-m.png"
              : "/assets/images/leaderboard/nav-leaderboard-d.png"
          }
          alt="CHRISTMAS LEADERBOARD"
          className="w-full h-auto rounded-lg"
        />
      </a>
    </div>
  );
};

export default BlackFridayLeaderBoardNavMenu;
